import React from "react";

const Reports = ({ ...rest }) => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M16.3327 2.64779V7.46675C16.3327 8.12015 16.3327 8.44684 16.4598 8.69641C16.5717 8.91593 16.7502 9.09441 16.9697 9.20626C17.2193 9.33342 17.546 9.33342 18.1994 9.33342H23.0183M16.3327 19.8333H9.33268M18.666 15.1667H9.33268M23.3327 11.6529V20.0667C23.3327 22.0269 23.3327 23.0069 22.9512 23.7556C22.6156 24.4142 22.0802 24.9496 21.4217 25.2852C20.673 25.6667 19.6929 25.6667 17.7327 25.6667H10.266C8.30583 25.6667 7.32574 25.6667 6.57705 25.2852C5.91848 24.9496 5.38305 24.4142 5.04749 23.7556C4.66602 23.0069 4.66602 22.0269 4.66602 20.0667V7.93334C4.66602 5.97315 4.66602 4.99306 5.04749 4.24437C5.38305 3.5858 5.91848 3.05037 6.57705 2.71481C7.32574 2.33334 8.30583 2.33334 10.266 2.33334H14.0131C14.8692 2.33334 15.2972 2.33334 15.7 2.43004C16.0571 2.51578 16.3985 2.65719 16.7117 2.8491C17.0649 3.06554 17.3676 3.36821 17.9729 3.97354L21.6925 7.69313C22.2978 8.29846 22.6005 8.60113 22.8169 8.95434C23.0088 9.26749 23.1502 9.6089 23.236 9.96602C23.3327 10.3688 23.3327 10.7969 23.3327 11.6529Z"
                stroke="#2A2E44"
                strokeWidth="2.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Reports;
